import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OverviewStaleStateService {
  private layoutsStaleSource = new Subject<void>();

  layoutsStale$ = this.layoutsStaleSource.asObservable();

  constructor() {}

  markLayoutsAsStale(): void {
    this.layoutsStaleSource.next();
  }
} 